import { Duration } from 'dayjs/plugin/duration.js';
import { TimeZone } from '../../../time/timezone.js';
import { isSameData, SerializedData } from '../../dto/dto.js';
import { TimeOfDay } from '../time-of-day.js';
import { CalendarDaySlot } from './calendar-day-slot.js';

export class SingleEntryCalendarSlot extends CalendarDaySlot {
  constructor(
    public readonly entryId: string,
    public readonly timeOfDay: TimeOfDay,
    public readonly duration: Duration,
  ) {
    super();
  }

  clone(): this {
    return new SingleEntryCalendarSlot(
        this.entryId,
        this.timeOfDay.clone(),
        TimeZone.cloneDuration(this.duration),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.entryId === this.entryId &&
        isSameData(other.timeOfDay, this.timeOfDay) &&
        other.duration === this.duration;
  }

  toDiagnosticsObject(): SerializedData {
    return {
      'entryId': this.entryId,
      'timeOfDay': this.timeOfDay.asFormattedString,
      'duration': this.duration.asMinutes(),
    };
  }
}
